'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _infiniteloader = require('./infiniteloader');

var _infiniteloader2 = _interopRequireDefault(_infiniteloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _infiniteloader2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/infiniteloader/index.js
// module id = 86
// module chunks = 0